import store from '../../store'

export default class RequestManagement {
    constructor() {
        ////console.log($store.state.settings.VacationBudgeCount);
    }
    VacationManagement() {
        var budge = store.getters.VacationBudgeCount;
        ////console.log(budge);
        return {
            id: "nav-vacation-management",
            title: "nav-vacation-management",
            icon: "",
            to: "vacation-management",
            subItems: [],
            budge: budge,
            order: 1,
        }
    }
    MissionManagement() {
        var budge = store.getters.MissionBudgeCount;
        ////console.log(budge);
        return {
            id: "nav-mission-management",
            title: "nav-mission-management",
            icon: "",
            to: "mission-management",
            subItems: [],
            budge: budge,
            order: 2,
        }
    }
    IOManagement() {
        var budge = store.getters.IOBudgeCount;
        ////console.log(budge);
        return {
            id: "nav-io-management",
            title: "nav-io-management",
            icon: "",
            to: "io-management",
            subItems: [],
            budge: budge,
            order: 3,
        }
    }
    ExtraWorkManagement() {
        var budge = store.getters.ExtraWorkBudgeCount;
        ////console.log(budge);
        return {
            id: "nav-extra-work-management",
            title: "nav-extra-work-management",
            icon: "",
            to: "extra-work-management",
            subItems: [],
            budge: budge,
            order: 4,
        }
    }
    AdminApprovalLevelInfo() {
        return {
            id: "nav-admin-approval-level-info",
            title: "nav-admin-approval-level-info",
            icon: "",
            to: "admin-approval-level-info",
            subItems: [],
            order: 9,
        }
    }
    ExtraWorkSpecificManagement() {
        var budge = store.getters.ExtraWorkManagementBudgeCount;
        ////console.log(budge);
        return {
            id: "nav-specific-extrawork-view",
            title: "nav-specific-extrawork-view",
            icon: "",
            to: "specific-extrawork-view",
            subItems: [],
            budge: budge,
            order: 11,
         
        }
    }
}